import { redirect } from 'react-router-dom';
import { getUserIsLoggendin } from 'containers/User/service';
import { set } from 'utils/LocalStorageUtil';
import { setTimer } from './Timer';
import { store } from '../store';
import { getRegion } from './Region';

const ERROR_CODE_TERMS_NOT_ACCEPTED = 'accept_terms';

const DEFAULT_CONFIG = {
  time: 240,
  enable: false,
};

const DEFAULT_SESION = {
  isValid: false,
  isTermsAccepted: false,
  code: undefined,
};

const transformMinutesToMs = minutes => minutes * 60 * 1000;

const getSession = async () => {
  try {
    const claroLiteConfig =
      JSON.parse(store.getState().metadata?.cv_advertising_config || '{}')?.[
        getRegion()
      ]?.enable || false;
    const {
      response: { is_user_logged_in, accepted_terms },
      errors,
    } = await getUserIsLoggendin({
      claroLiteConfig: claroLiteConfig,
    });

    return {
      isValid: is_user_logged_in,
      isTermsAccepted: accepted_terms,
      code: errors?.code,
    };
  } catch (error) {
    return DEFAULT_SESION;
  }
};

export const setIntervalSessionValidator = (config, region) => {
  const { time, enable } =
    config?.[region] || config?.default || DEFAULT_CONFIG;

  if (!enable) return;

  const delayInMs = transformMinutesToMs(time);

  setTimer({
    id: 'svt',
    delay: delayInMs,
    config,
  }).then(async timer => {
    const { isValid, isTermsAccepted, code } = await getSession();

    if (isValid === 0) return window.location.replace('/');

    if (isTermsAccepted === 0 && code === ERROR_CODE_TERMS_NOT_ACCEPTED) {
      const isPlayerActive = window.location.pathname.includes('/watch');
      if (!isPlayerActive) {
        set('loginInfo.acceptedTerms', 0);
        location.replace(`/${region}/terms`);
      }
    }

    return setIntervalSessionValidator(timer.config);
  });
};
